export const handleResponseError = (error, store, router) => {
  const status = error.response && error.response.status;

  if (status === 401) {
    store.dispatch('auth/logout');
    router.push('/login?disconnected=true');
  }
  if (status === 403) {
    router.push('/');
  }

  return Promise.reject(error);
};
